import { render, staticRenderFns } from "./ModalAtualizEscolaridade.vue?vue&type=template&id=b676882a&"
import script from "./ModalAtualizEscolaridade.vue?vue&type=script&lang=js&"
export * from "./ModalAtualizEscolaridade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports